module.exports = __webpack_public_path__ + "static/images/productDetail.e49a146.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/modernPropertyInsurance/productDetail.png
// module id = zZFX
// module chunks = 0